// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"122":"c18e55b4","453":"f1f4ea31"}[chunkId] + ".chunk.js");